import { gql } from 'graphql-request';

export const GET_FULL_ITEM_BY_GTIN_QUERY = gql`
  query ($gtin: String!, $businessUnitGroupId: String, $businessUnitId: String) {
    itemIdentifier(
      gtin: $gtin
      businessUnitGroupId: $businessUnitGroupId
      businessUnitId: $businessUnitId
    ) {
      item {
        id
        name
        description
        images {
          url
          size
        }
        depositAndFeeRuleIds
        salesUnitOfMeasurement
        priceSpecifications(currentOnly: true, type: SALES) {
          value
          currencyId
          taxRuleId
          taxableGroupId
        }
        additionalProperties {
          id
          name
          code
          description
          dataType
          value
          isMandatory
        }
      }
    }
  }
`;
